import React, { useState, useEffect, useContext } from 'react';
//import PropTypes from 'prop-types';
import SiteWrapper from "../../SiteWrapper.react";
import Select from "react-select";
import { Crud_Catalogos, Crud_error } from '../../herramientas/Crud_Catalogos';
import { timeToYearmonthDay, timeToGMTS } from "../../herramientas/DateFormat";
import { softphoneContext } from "../../context/softphoneContext";
import { TablePageable } from "../../Helpers";
import AudioPlayer from './AudioPlayer';

let offset = 0;
let limit = 1000;
let dataTem = [];
let contador = 1;
const perfil = JSON.parse(sessionStorage.getItem("perfil"));

const ReportesLLAmadasPagev2 = () => {
  const softphone = useContext(softphoneContext);
  const [funcionalidades, setFuncionalidades] = useState([]);
  const [troncales, setTroncales] = useState([]);
  const [fecha1, setFecha1] = useState(timeToYearmonthDay(new Date().getTime()));
  const [fecha2, setFecha2] = useState(timeToYearmonthDay(new Date().getTime()));
  const [grupos, setGrupos] = useState([]);
  const [grupo, setGrupo] = useState({ value: 0, label: "Todas las centrales", data: null });
  const [reporte, setReporte] = useState([]);
  const [reporteProcesado, setReporteProcesado] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedUniqueId, setSelectedUniqueId] = useState(null);
  const [historialLlamada, setHistorialLlamada] = useState([]);
  
  // Estados para el progreso
  const [cargandoReporte, setCargandoReporte] = useState(false);
  const [progresoReporte, setProgresoReporte] = useState({
    actual: 0,
    total: 0,
    porcentaje: 0,
    mensaje: ''
  });

  useEffect(() => {
    crud("get", "", "", "funcionalidades/reporte_llamadas/" + perfil.id, "funcionalidades");
  }, []);

  useEffect(() => {
    if (funcionalidades.length) {
      crud("get", "", "", "softphone_configuracion", "softphonePlataforma");
    }
  }, [funcionalidades]);

  useEffect(() => {
    if (troncales.length) {
      crud("get", "", "", "softphone_v2/grupos/2", "grupos");
    }
  }, [troncales]);

  const obtenerReporte = async () => {
    let dataResp = [];
    let totalRegistros = 0;
    let registrosCargados = 0;

    await crud("get", "", "", "softphone_v2/reporte?provedor=2&f1=" + fecha1 + " 00:00:00&f2=" + fecha2 + " 23:59:59&offset=" + offset + "&limit=" + limit, "reporte").then((returnVal) => {//&localidad=" + grupo.data.extension + "
      contador++;
      if (returnVal.data && returnVal.data.data) {
        dataResp = returnVal.data.data;
        
        // Obtener el total de registros de los metadatos
        if (returnVal.data.meta) {
          totalRegistros = returnVal.data.meta.total;
          registrosCargados = returnVal.data.meta.offset + returnVal.data.data.length;
          
          const porcentaje = Math.round((registrosCargados / totalRegistros) * 100);
          
          setProgresoReporte({
            actual: registrosCargados,
            total: totalRegistros,
            porcentaje: porcentaje,
            mensaje: ""//`Cargando registros... ${registrosCargados} de ${totalRegistros}`
          });
        }

        let dataFiltrada = [];
        let troncalTemp = troncales.filter(t => (!grupo.value || t.idGrupo === grupo.value) && t.softphoneConfiguracionId === 2);//troncalTemp[0].extension
        console.log(troncalTemp);
        console.log(troncalTemp[0].caller_id);
        for (let r of dataResp) {
          if( troncalTemp.length > 1){
            dataFiltrada.push(r);
          }else{
            if ( r.src === troncalTemp[0].caller_id || r.dst === troncalTemp[0].caller_id ) {
              dataFiltrada.push(r);
            }
          }
        }
        /*
        for (let r of dataResp) {
          if (grupo.data.id === r.localidad_id) {
            dataFiltrada.push(r);
          }
        }
        */
        
        dataTem = [...dataTem, ...dataFiltrada];
        setReporte(dataTem);
        
        // Procesar el reporte para obtener un único elemento por uniqueid
        const procesado = procesarReporte(dataTem);
        setReporteProcesado(procesado);
      }
    });

    setTimeout(() => {
      if (dataResp.length && registrosCargados < totalRegistros) {
        offset = offset + limit;
        obtenerReporte();
      } else {
        // Finalizar carga
        setCargandoReporte(false);
        setProgresoReporte({
          actual: registrosCargados,
          total: totalRegistros,
          porcentaje: 100,
          mensaje: `Completado: ${registrosCargados} registros cargados`
        });
        
        // Limpiar mensaje después de 3 segundos
        setTimeout(() => {
          setProgresoReporte(prev => ({
            ...prev,
            mensaje: ''
          }));
        }, 3000);
      }
    }, 200);
  };

  const crud = (metodo = "get", obj = [], id = "", catalogo = "", stateVar = "", hiddenModl = "") => {
    return Crud_Catalogos(catalogo, "movimientos", metodo, id, obj, "", stateVar, hiddenModl, []).then((returnVal) => {
      switch (metodo) {
        case "get":
          if (stateVar === "obtener_audio") {
            console.log(returnVal);
            return returnVal;
          }
          if (stateVar === "funcionalidades") {
            setFuncionalidades(returnVal);
          }
          if (stateVar === "softphonePlataforma") {
            setTroncales(returnVal);
          }
          if (stateVar === "grupos") {
            let gruposTemp = [{ value: 0, label: "Todas las centrales", data: null }];
            console.log(returnVal.data);
            for (let g of returnVal.data) {
              let troncalTemp = troncales.filter(t => t.idGrupo === g.id && t.softphoneConfiguracionId === 2);
              if (troncalTemp.length === 1) {
                g.extension = troncalTemp[0].extension;
                gruposTemp.push({ value: g.id, label: g.name, data: g });
                if (g.id === softphone.getValues().grupo) {
                  setGrupo(gruposTemp[gruposTemp.length - 1]);
                }
              }
            }
            setGrupos(gruposTemp);
          }
          if (stateVar === "reporte") {
            return returnVal;
          }
          break;
        default:
          break;
      }
    }).catch(err => { console.log(err); });
  }

  // Función para calcular el tiempo total de llamada por uniqueid
  const calcularTiempoTotal = (uniqueid, reporteData) => {
    const llamadasRelacionadas = reporteData.filter(item => item.uniqueid === uniqueid);
    const tiempoTotal = llamadasRelacionadas.reduce((suma, item) => {
      return suma + parseInt(item.duration || 0);
    }, 0);

    // Convertir segundos a formato HH:MM:SS
    const formatearTiempo = (segundos) => {
      const horas = Math.floor(segundos / 3600);
      const minutos = Math.floor((segundos % 3600) / 60);
      const segs = segundos % 60;

      return `${horas.toString().padStart(2, '0')}:${minutos.toString().padStart(2, '0')}:${segs.toString().padStart(2, '0')}`;
    };

    return formatearTiempo(tiempoTotal);
  };

  // Función para procesar el reporte y obtener un único elemento por uniqueid
  const procesarReporte = (reporteData) => {
    // Agrupar por uniqueid
    const agrupados = reporteData.reduce((acc, item) => {
      if (!acc[item.uniqueid]) {
        acc[item.uniqueid] = [];
      }
      acc[item.uniqueid].push(item);
      return acc;
    }, {});

    // Procesar cada grupo para obtener el registro representativo
    const procesados = Object.keys(agrupados).map(uniqueid => {
      const registros = agrupados[uniqueid];

      // Buscar el registro con disposition "ANSWERED"
      const answered = registros.find(registro => registro.disposition === "ANSWERED" && registro.peeraccount);

      if (answered) {
        // Si hay un registro ANSWERED, usarlo como base
        return {
          ...answered,
          // Calcular el tiempo total sumando todas las duraciones
          tiempoTotal: registros.reduce((suma, reg) => suma + parseInt(reg.duration || 0), 0),
          // Mantener información de todos los registros si es necesario
          totalRegistros: registros.length
        };
      } else {
        // Si no hay ANSWERED, tomar el último según calldate
        const ordenados = registros.sort((a, b) => new Date(b.calldate) - new Date(a.calldate));
        const ultimo = ordenados[0];

        return {
          ...ultimo,
          // Calcular el tiempo total sumando todas las duraciones
          tiempoTotal: registros.reduce((suma, reg) => suma + parseInt(reg.duration || 0), 0),
          // Mantener información de todos los registros si es necesario
          totalRegistros: registros.length
        };
      }
    });

    return procesados;
  };

  // Actualizar la columna "Tiempo de Llamada" para usar tiempoTotal
  const formatearTiempo = (segundos) => {
    const horas = Math.floor(segundos / 3600);
    const minutos = Math.floor((segundos % 3600) / 60);
    const segs = segundos % 60;

    return `${horas.toString().padStart(2, '0')}:${minutos.toString().padStart(2, '0')}:${segs.toString().padStart(2, '0')}`;
  };

  // Función para obtener el historial de una llamada específica
  const obtenerHistorialLlamada = (uniqueid) => {
    const historial = reporte.filter(item => item.uniqueid === uniqueid);
    // Ordenar por calldate para mostrar cronológicamente
    return historial.sort((a, b) => new Date(a.calldate) - new Date(b.calldate));
  };

  // Función para formatear la duración
  const formatearDuracion = (segundos) => {
    const mins = Math.floor(segundos / 60);
    const secs = segundos % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  // Función para obtener el color del estado
  const getStatusColor = (disposition) => {
    switch (disposition) {
      case 'ANSWERED': return '#28a745';
      case 'NO ANSWER': return '#dc3545';
      case 'BUSY': return '#ffc107';
      case 'FAILED': return '#dc3545';
      default: return '#6c757d';
    }
  };

  // Función para obtener el icono del estado
  const getStatusIcon = (disposition) => {
    switch (disposition) {
      case 'ANSWERED': return '✓';
      case 'NO ANSWER': return '✗';
      case 'BUSY': return '⏳';
      case 'FAILED': return '⚠';
      default: return '○';
    }
  };

  const ModalHistorial = () => {
    if (!showModal) return null;

    return (
      <div
        className="modal fade show"
        style={{
          display: 'block',
          backgroundColor: 'rgba(0,0,0,0.5)',
          zIndex: 1050
        }}
        onClick={(e) => {
          // Cerrar modal al hacer clic en el backdrop
          if (e.target === e.currentTarget) {
            setShowModal(false);
          }
        }}
      >
        <div className="modal-dialog modal-lg modal-dialog-scrollable">
          <div className="modal-content" style={{ maxHeight: '90vh' }}>
            <div className="modal-header sticky-top bg-white border-bottom">
              <h5 className="modal-title">
                Historial de Llamada - ID: {selectedUniqueId}
                <small className="text-muted ms-2">
                  ({historialLlamada.length} eventos)
                </small>
              </h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => setShowModal(false)}
                aria-label="Cerrar"
              ></button>
            </div>
            <div
              className="modal-body"
              style={{
                maxHeight: 'calc(90vh - 140px)',
                overflowY: 'auto',
                padding: '1rem'
              }}
            >
              <div className="timeline">
                {historialLlamada.map((evento, index) => (
                  <div key={index} className="timeline-item mb-3">
                    <div className="row">
                      <div className="col-2 text-center">
                        <div
                          className="timeline-marker rounded-circle d-flex align-items-center justify-content-center"
                          style={{
                            backgroundColor: getStatusColor(evento.disposition),
                            width: '40px',
                            height: '40px',
                            color: 'white',
                            fontWeight: 'bold',
                            fontSize: '14px'
                          }}
                        >
                          {getStatusIcon(evento.disposition)}
                        </div>
                        {index < historialLlamada.length - 1 && (
                          <div
                            className="timeline-line"
                            style={{
                              width: '2px',
                              height: '60px',
                              backgroundColor: '#dee2e6',
                              margin: '5px auto'
                            }}
                          ></div>
                        )}
                      </div>
                      <div className="col-10">
                        <div className="card shadow-sm">
                          <div className="card-body p-3">
                            <div className="row">
                              <div className="col-md-6">
                                <h6 className="card-title mb-1">
                                  <span
                                    className="badge"
                                    style={{ backgroundColor: getStatusColor(evento.disposition) }}
                                  >
                                    {evento.disposition}
                                  </span>
                                </h6>
                                <p className="card-text mb-1">
                                  <strong>Fecha:</strong> {evento.calldate}
                                </p>
                                <p className="card-text mb-1">
                                  <strong>Duración:</strong> {formatearDuracion(parseInt(evento.duration || 0))}
                                </p>
                                <p className="card-text mb-1">
                                  <strong>Tipo:</strong> {evento.type}
                                </p>
                              </div>
                              <div className="col-md-6">
                                <p className="card-text mb-1">
                                  <strong>Origen:</strong> {evento.src}
                                </p>
                                <p className="card-text mb-1">
                                  <strong>Destino:</strong> {evento.dst}
                                </p>
                                <p className="card-text mb-1">
                                  <strong>Usuario:</strong> {evento.peeraccount}
                                </p>
                                <p className="card-text mb-1">
                                  <strong>Canal:</strong> {evento.dstchannel}
                                </p>
                              </div>
                            </div>                            
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="modal-footer sticky-bottom bg-white border-top">
              <div className="d-flex justify-content-between w-100">
                <small className="text-muted">
                  Total de eventos: {historialLlamada.length}
                </small>
                <small className="mt-1">
                  <AudioPlayer
                    uniqueid={selectedUniqueId}
                    funcionalidades={funcionalidades}
                  />
                </small>
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cerrar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // Función para abrir el modal con el historial
  const abrirModalHistorial = (uniqueid) => {
    setSelectedUniqueId(uniqueid);
    const historial = obtenerHistorialLlamada(uniqueid);
    setHistorialLlamada(historial);
    setShowModal(true);
  };

  // Componente de Progress Bar
  const ProgressBar = () => {
    if (!cargandoReporte && !progresoReporte.mensaje) return null;

    return (
      <div className="mb-4">
        <div className="card">
          <div className="card-body p-3">
            <div className="d-flex align-items-center mb-2">
              {cargandoReporte && (
                <div className="spinner-border spinner-border-sm text-primary me-2" role="status">
                  <span className="visually-hidden">Cargando...</span>
                </div>
              )}
              <span className="fw-bold text-primary">
                {progresoReporte.mensaje || 'Generando reporte...'}
              </span>
            </div>
            
            {progresoReporte.total > 0 && (
              <>
                <div className="progress mb-2" style={{ height: '8px' }}>
                  <div
                    className="progress-bar progress-bar-striped"
                    role="progressbar"
                    style={{
                      width: `${progresoReporte.porcentaje}%`,
                      backgroundColor: cargandoReporte ? '#007bff' : '#28a745'
                    }}
                    aria-valuenow={progresoReporte.porcentaje}
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>
                <div className="d-flex justify-content-between">
                  {/*
                  <small className="text-muted">
                    Progreso: {progresoReporte.actual} / {progresoReporte.total} registros
                  </small>*/}
                  <small className="text-muted">
                    {progresoReporte.porcentaje}%
                  </small>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    );
  };

  return (
    <SiteWrapper>
      {funcionalidades.filter(f => f.nombre === "ver_reporte").length ?
        <div className='container-fluid p-6'>
          <h5> Grabaciones de llamadas </h5>
          <hr color='white' />
          
          {/* Progress Bar */}
          <ProgressBar />
          
          <div className='row mt-5'>
            <div className='col-12'>
              <TablePageable
                titulo={
                  <div className="row">
                    <div className='col'>
                      <label>Fecha inicio</label>
                      <input className="form-control" type="date" id="start" name="trip-start"
                        value={fecha1}
                        onChange={(e) => {
                          setFecha1(e.target.value);
                          if (new Date(e.target.value).getTime() > new Date(fecha2).getTime()) {
                            setFecha2(e.target.value);
                          } else {
                            if ((new Date(fecha2).getTime() - new Date(e.target.value).getTime()) > (31 * 24 * 60 * 60 * 1000)) {
                              setFecha2(timeToYearmonthDay(new Date(e.target.value).getTime() + (31 * 24 * 60 * 60 * 1000)));
                            }
                          }
                        }}
                        min="2024-05-01" max={timeToYearmonthDay(new Date().getTime())} />
                    </div>
                    <div className='col'>
                      <label>Fecha fin</label>
                      <input className="form-control" type="date" id="start" name="trip-start"
                        value={fecha2}
                        onChange={(e) => {
                          setFecha2(e.target.value);
                          if (new Date(e.target.value).getTime() < new Date(fecha1).getTime()) {
                            setFecha1(e.target.value);
                          } else {
                            if ((new Date(e.target.value).getTime() - new Date(fecha1).getTime()) > (31 * 24 * 60 * 60 * 1000)) {
                              setFecha1(timeToYearmonthDay(new Date(e.target.value).getTime() - (31 * 24 * 60 * 60 * 1000)));
                            }
                          }
                        }}
                        min="2024-05-01" max={timeToYearmonthDay(new Date().getTime())} />
                    </div>
                    <div className='col' hidden={funcionalidades.filter(f => f.nombre === "grupos_agentes").length === 0}>
                      <label>Grupos</label>
                      <Select value={grupo} onChange={(e) => setGrupo(e)} options={grupos} isDisabled={cargandoReporte} />
                    </div>
                    <div className='col-1'>
                      <i className={`fa ${cargandoReporte ? 'fa-spinner fa-spin' : 'fa-refresh'} text-primary btn`}
                        style={{ fontSize: "40px", opacity: cargandoReporte ? 0.6 : 1 }}
                        data-toggle="tooltip"
                        data-placement="top"
                        title={cargandoReporte ? "Cargando..." : "Actualizar"}
                        onClick={() => {
                          if (!cargandoReporte) {//!cargandoReporte && grupo.data
                            offset = 0;
                            dataTem = [];
                            contador = 1;
                            setReporte([]);
                            setReporteProcesado([]);
                            obtenerReporte();

                            setCargandoReporte(true);
                            setProgresoReporte({
                              actual: 0,
                              total: 0,
                              porcentaje: 0,
                              mensaje: 'Iniciando consulta...'
                            });
                          }
                        }}></i>
                    </div>
                  </div>
                }
                lista={reporteProcesado}
                columnas={
                  [
                    { columna: "start", label: "Inicio" },
                    { columna: "end", label: "Fin" },
                    { columna: "uniqueid", label: "ID" },
                    { columna: "lastapp", label: "lastapp" },
                    { columna: "peeraccount", label: "Agente" },
                    { columna: "src", label: "Origen" },
                    { columna: "dst", label: "Destino" },
                    {
                      columna: "tiempo_total",
                      label: "Tiempo de Llamada",
                      form: (e) => {
                        return formatearTiempo(e.tiempoTotal || 0);
                      },
                      valor: (e) => {
                        return formatearTiempo(e.tiempoTotal || 0);
                      }
                    },
                    {
                      columna: "tiempo_total_seg",
                      label: "Tiempo en seg",
                      form: (e) => {
                        return e.tiempoTotal;
                      },
                      valor: (e) => {
                        return e.tiempoTotal;
                      }
                    },
                    { columna: "type", label: "Tipo" },
                    { columna: "disposition", label: "Disposición" },
                    {
                      columna: "detalle",
                      label: "Detalle",
                      form: (e) => {
                        // Contar cuántos registros tiene este uniqueid
                        const totalEventos = reporte.filter(item => item.uniqueid === e.uniqueid).length;
                        return (
                          <div
                            className="btn"
                            onClick={() => abrirModalHistorial(e.uniqueid)}
                            title={`Ver historial completo (${totalEventos} eventos)`}
                          >
                            <i className="fa fa-eye"></i> Ver ({totalEventos})
                          </div>
                        );
                      }
                    },/*
                    {
                      columna: "audio", label: "Audio",
                      form: (e) => {
                        if (funcionalidades.filter(f => f.nombre === "audio").length) {
                          return <AudioPlayer
                            uniqueid={e.uniqueid}
                            funcionalidades={funcionalidades}
                          />;
                        } else {
                          return "";
                        }
                      }
                    },*/
                  ]
                }
                id="uniqueid"
                csvname={funcionalidades.filter(f => f.nombre === "exportar").length ? ("Reporte de llamadas " + grupo.label) : null}
                paginacion={true}
                elementosPorPagina={15}
              />
            </div>
          </div>
        </div>
        : null
      }
      <ModalHistorial />
    </SiteWrapper>
  );
}

export default ReportesLLAmadasPagev2;